<template>
  <v-app id="inspire" dark>
    <v-navigation-drawer v-model="drawer" clipped fixed app>
      <v-list>
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="settings">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Savings</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout justify-center align-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app fixed>
      <span class="ml-3">&copy; TSoftware 2019</span>
    </v-footer>
  </v-app>
</template>
<script>
import firebase from "firebase";
export default {
  data: () => ({
    drawer: null
  }),
  methods: {
    logout() {
      this.$store.dispatch("userSignOut");
    },
    mounted() {
      // Retrieve Firebase Messaging object.
      const messaging = firebase.messaging();
      // Add the public key generated from the console here.
      messaging.usePublicVapidKey(
        "BJ8NlX9ZetBNZikfQO6j2NCw2QSB2EHfFjEKMxF1cxeCr4gqSMrmXO5l6E83s7cMzGmQAQjJTxF2XswQp5F2b-g"
      );
      messaging
        .requestPermission()
        .then(function() {
          console.log("Notification permission granted.");
          // Get Instance ID token. Initially this makes a network call, once retrieved
          // subsequent calls to getToken will return from cache.
          messaging
            .getToken()
            .then(function(currentToken) {
              if (currentToken) {
                sendTokenToServer(currentToken);
                updateUIForPushEnabled(currentToken);
              } else {
                // Show permission request.
                console.log(
                  "No Instance ID token available. Request permission to generate one."
                );
                // Show permission UI.
                updateUIForPushPermissionRequired();
                setTokenSentToServer(false);
              }
            })
            .catch(function(err) {
              console.log("An error occurred while retrieving token. ", err);
              showToken("Error retrieving Instance ID token. ", err);
              setTokenSentToServer(false);
            });
          // Callback fired if Instance ID token is updated.
          messaging.onTokenRefresh(function() {
            messaging
              .getToken()
              .then(function(refreshedToken) {
                console.log("Token refreshed.");
                // Indicate that the new Instance ID token has not yet been sent to the
                // app server.
                setTokenSentToServer(false);
                // Send Instance ID token to app server.
                sendTokenToServer(refreshedToken);
                // ...
              })
              .catch(function(err) {
                console.log("Unable to retrieve refreshed token ", err);
                showToken("Unable to retrieve refreshed token ", err);
              });
          });
        })
        .catch(function(err) {
          console.log("Unable to get permission to notify.", err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
